import { render, staticRenderFns } from "./BeltsSelect.vue?vue&type=template&id=4450fbd9&scoped=true"
import script from "./BeltsSelect.vue?vue&type=script&lang=js"
export * from "./BeltsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4450fbd9",
  null
  
)

export default component.exports